export default __webpack_public_path__ + "src/images/galleries/0/btn_enter_en-8d7dbf.png";